/**
 * Validate a JWT against your backend.
 * @param {string} token - The JWT you want to validate.
 * @returns {Promise<{valid: boolean, user?: object, error?: string}>}
 */

import config from "../config/config.json";

export async function validateToken(token) {
  console.log("Token validation started");
  try {
    const res = await fetch(config.APP_URL + "/utahdata/validate-token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // If you prefer an Authorization header, uncomment the next line
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ token }), // or omit if you use the header
    });

    // Handle non-200 responses early
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    // Ensure the server replied with JSON
    const ctype = res.headers.get("content-type") || "";
    if (!ctype.includes("application/json")) {
      throw new Error("Response was not JSON");
    }

    const data = await res.json();

    console.log(data)

    return data
      ? { valid: true, user: data.user }
      : { valid: false, error: data.error || "Invalid token" };
  } catch (err) {
    console.error("Token validation failed:", err.message);
    return { valid: false, error: err.message };
  }
}
